import React, { useMemo, useState } from "react";
import SEO from "../components/SEO";

import studioImage01 from "../assets/studio-images/studio-image01.jpg";
import studioImage02 from "../assets/studio-images/studio-image02.jpg";
import studioImage03 from "../assets/studio-images/studio-image03.jpg";
import studioImage04 from "../assets/studio-images/studio-image04.jpg";
import studioImage05 from "../assets/studio-images/studio-image05.jpg";
import studioImage06 from "../assets/studio-images/studio-image06.jpg";
import studioImage07 from "../assets/studio-images/studio-image07.jpg";
import studioImage08 from "../assets/studio-images/studio-image08.jpg";
import studioImage09 from "../assets/studio-images/studio-image09.jpg";
import studioImage10 from "../assets/studio-images/studio-image10.jpg";
import studioImage11 from "../assets/studio-images/studio-image11.jpg";
import studioImage12 from "../assets/studio-images/studio-image12.jpg";
import studioImage13 from "../assets/studio-images/studio-image13.jpg";
import studioImage14 from "../assets/studio-images/studio-image14.jpg";
import studioImage15 from "../assets/studio-images/studio-image15.jpg";
import studioImage16 from "../assets/studio-images/studio-image16.jpg";
import studioImage17 from "../assets/studio-images/studio-image17.jpg";
import studioImage18 from "../assets/studio-images/studio-image18.jpg";
import studioImage19 from "../assets/studio-images/studio-image19.jpg";
import studioImage20 from "../assets/studio-images/studio-image20.jpg";
import studioImage21 from "../assets/studio-images/studio-image21.jpg";
import studioImage22 from "../assets/studio-images/studio-image22.jpg";
import studioImage23 from "../assets/studio-images/studio-image23.jpg";
import studioImage24 from "../assets/studio-images/studio-image24.jpg";
import studioImage25 from "../assets/studio-images/studio-image25.jpg";
import studioImage26 from "../assets/studio-images/studio-image26.jpg";
import studioImage27 from "../assets/studio-images/studio-image27.jpg";
import studioImage28 from "../assets/studio-images/studio-image28.jpg";
import studioImage29 from "../assets/studio-images/studio-image29.jpg";
import studioImage30 from "../assets/studio-images/studio-image30.jpg";
import studioImage31 from "../assets/studio-images/studio-image31.jpg";
import studioImage32 from "../assets/studio-images/studio-image32.jpg";
import studioImage33 from "../assets/studio-images/studio-image33.jpg";
import studioImage34 from "../assets/studio-images/studio-image34.jpg";
import studioImage35 from "../assets/studio-images/studio-image35.jpg";
import studioImage36 from "../assets/studio-images/studio-image36.jpg";
import studioImage37 from "../assets/studio-images/studio-image37.jpg";
import studioImage38 from "../assets/studio-images/studio-image38.jpg";
import studioImage39 from "../assets/studio-images/studio-image39.jpg";
import studioImage40 from "../assets/studio-images/studio-image40.jpg";
import studioImage41 from "../assets/studio-images/studio-image41.jpg";

const STUDIO_IMAGES = [
  studioImage01,
  studioImage02,
  studioImage03,
  studioImage04,
  studioImage05,
  studioImage06,
  studioImage07,
  studioImage08,
  studioImage09,
  studioImage10,
  studioImage11,
  studioImage12,
  studioImage13,
  studioImage14,
  studioImage15,
  studioImage16,
  studioImage17,
  studioImage18,
  studioImage19,
  studioImage20,
  studioImage21,
  studioImage22,
  studioImage23,
  studioImage24,
  studioImage25,
  studioImage26,
  studioImage27,
  studioImage28,
  studioImage29,
  studioImage30,
  studioImage31,
  studioImage32,
  studioImage33,
  studioImage34,
  studioImage35,
  studioImage36,
  studioImage37,
  studioImage38,
  studioImage39,
  studioImage40,
  studioImage41,
];

// const EVENT_IMAGES = [

// ];

const TABS = [
  {
    id: "studio",
    label: "Studio",
    title: "Studio Gallery",
    description: "Browse moments captured during our studio sessions.",
    images: STUDIO_IMAGES,
  },
  //   {
  //     id: "events",
  //     label: "Events",
  //     title: "Events Gallery",
  //     description: "Event highlights will appear here once added.",
  //     images: EVENT_IMAGES,
  //   },
];

function Lightbox({ images, currentIndex, onClose, onPrev, onNext }) {
  if (!images.length) return null;

  return (
    <>
      <SEO
        title="Photography Gallery | Kinews Studio Limited"
        description="Browse our photography gallery showcasing studio sessions, events and creative work captured by Kinews Studio Limited."
        url={window.location.href}
      />
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4">
        <button
          type="button"
          onClick={onClose}
          aria-label="Close preview"
          className="absolute right-4 top-4 z-10 flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-white/10 text-white transition hover:bg-white/20"
        >
          ✕
        </button>

        {images.length > 1 && (
          <button
            type="button"
            onClick={onPrev}
            aria-label="Previous image"
            className="absolute left-4 top-1/2 z-10 flex h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full border border-white/15 bg-white/10 text-white transition hover:bg-white/20"
          >
            ‹
          </button>
        )}

        <div className="mx-auto w-full max-w-5xl overflow-hidden rounded-[2rem] border border-white/10 bg-black">
          <img
            src={images[currentIndex]}
            alt={`Gallery preview ${currentIndex + 1}`}
            className="max-h-[85vh] w-full object-contain"
          />
        </div>

        {images.length > 1 && (
          <button
            type="button"
            onClick={onNext}
            aria-label="Next image"
            className="absolute right-4 top-1/2 z-10 flex h-12 w-12 -translate-y-1/2 items-center justify-center rounded-full border border-white/15 bg-white/10 text-white transition hover:bg-white/20"
          >
            ›
          </button>
        )}

        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 rounded-full border border-white/10 bg-white/10 px-4 py-2 text-sm text-white/80">
          {currentIndex + 1} / {images.length}
        </div>
      </div>
    </>
  );
}

export default function Gallery() {
  const [activeTab, setActiveTab] = useState("studio");
  const [lightboxImages, setLightboxImages] = useState([]);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const activeSection = useMemo(
    () => TABS.find((tab) => tab.id === activeTab) || TABS[0],
    [activeTab],
  );

  const openLightbox = (images, index) => {
    setLightboxImages(images);
    setLightboxIndex(index);
  };

  const closeLightbox = () => {
    setLightboxImages([]);
    setLightboxIndex(0);
  };

  const showPrev = () => {
    setLightboxIndex((prev) =>
      prev === 0 ? lightboxImages.length - 1 : prev - 1,
    );
  };

  const showNext = () => {
    setLightboxIndex((prev) => (prev + 1) % lightboxImages.length);
  };

  return (
    <>
      <main className="min-h-screen bg-[#0b0b0c] text-white">
        <section className="relative overflow-hidden bg-[#050505] text-white">
          {/* Lighting Effects */}
          <div className="pointer-events-none absolute inset-0 overflow-hidden">
            <div className="absolute -left-[10%] -top-[10%] h-[40rem] w-[40rem] rounded-full bg-pink-500/15 blur-[120px]" />
            <div className="absolute -right-[10%] top-[20%] h-[35rem] w-[35rem] rounded-full bg-pink-600/10 blur-[100px]" />
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[50rem] w-[50rem] rounded-full bg-pink-500/5 blur-[150px]" />
          </div>

          <div className="relative mx-auto max-w-7xl px-5 pb-14 pt-28 md:pb-24 md:pt-40">
            <h1 className="mt-3 text-4xl font-bold tracking-tighter md:text-5xl lg:text-6xl">
              Gallery
            </h1>
            <p className="mt-6 max-w-xl text-lg leading-relaxed text-white/60 md:text-xl">
              Explore a curated collection of our style and creativity.
            </p>
          </div>
        </section>

        <section className="sticky top-0 z-30 border-b border-white/10 bg-[#0b0b0c]/90 backdrop-blur">
          <div className="mx-auto max-w-7xl px-5 py-4">
            <div className="inline-flex rounded-full border border-white/10 bg-white/[0.03] p-1">
              {TABS.map((tab) => {
                const active = activeTab === tab.id;

                return (
                  <button
                    key={tab.id}
                    type="button"
                    onClick={() => setActiveTab(tab.id)}
                    className={[
                      "rounded-full px-5 py-2.5 text-sm font-medium transition",
                      active
                        ? "bg-pink-500 text-white"
                        : "text-white/75 hover:bg-white/[0.06] hover:text-white",
                    ].join(" ")}
                  >
                    {tab.label}
                  </button>
                );
              })}
            </div>
          </div>
        </section>

        <section className="bg-[#0f1012]">
          <div className="mx-auto max-w-7xl px-5 py-16">
            <div className="mb-8 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
              <div>
                <p className="text-sm uppercase tracking-[0.25em] text-pink-400/80">
                  {activeSection.label}
                </p>
                <h2 className="mt-2 text-3xl font-semibold">
                  {activeSection.title}
                </h2>
                <p className="mt-3 max-w-2xl text-white/65">
                  {activeSection.description}
                </p>
              </div>

              <div className="rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 text-sm text-white/70">
                {activeSection.images.length} image
                {activeSection.images.length !== 1 ? "s" : ""}
              </div>
            </div>

            {activeSection.images.length === 0 ? (
              <div className="rounded-[2rem] border border-dashed border-white/15 bg-white/[0.03] px-6 py-14 text-center text-white/55">
                No images here yet. Event photos will appear in this tab later.
              </div>
            ) : (
              <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                {activeSection.images.map((img, index) => (
                  <button
                    key={`${activeSection.id}-${index}`}
                    type="button"
                    onClick={() => openLightbox(activeSection.images, index)}
                    className="group overflow-hidden rounded-[1.5rem] border border-white/10 bg-white/[0.03] text-left"
                  >
                    <div className="aspect-[4/5] overflow-hidden bg-black">
                      <img
                        src={img}
                        alt={`${activeSection.label} ${index + 1}`}
                        loading="lazy"
                        className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
                      />
                    </div>
                  </button>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>

      <Lightbox
        images={lightboxImages}
        currentIndex={lightboxIndex}
        onClose={closeLightbox}
        onPrev={showPrev}
        onNext={showNext}
      />
    </>
  );
}
